import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "一级团队名称", -1);

const _hoisted_2 = {
  class: "form"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "自动结算开关", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "settle-tips"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "red"
}, "自动结算仅支持线上支付订单。"), /*#__PURE__*/_createElementVNode("p", null, "将线上支付订单金额按分账规则进行系统自动结算，各方收到结算款后可进行提现。")], -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "平台服务费承担方", -1);

const _hoisted_9 = {
  class: "content"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createElementVNode("span", null, "平台服务费："), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "1%"), /*#__PURE__*/_createElementVNode("span", null, "结算时扣减承担方分账金额，若承担方分账金额不足以抵扣服务费系统将随机向其他可满足角色收取。")], -1);

const _hoisted_11 = /*#__PURE__*/_createTextVNode("新增承担方");

const _hoisted_12 = {
  class: "wrapper"
};

const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "业务员提现设置", -1);

const _hoisted_14 = {
  class: "content"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode("支持");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("不支持");

const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "支持："), /*#__PURE__*/_createElementVNode("span", null, "业务员分账金额"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "由平台代收"), /*#__PURE__*/_createElementVNode("span", null, "，业务员申请提现"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "团队审核后由平台打款至业务员账户。")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "不支持："), /*#__PURE__*/_createElementVNode("span", null, "业务员分账金额"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "打款至销售团队账户"), /*#__PURE__*/_createElementVNode("span", null, "，若销售团队无账户，打款至平台代收，"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "线下结算。")])], -1);

const _hoisted_18 = {
  class: "card"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现时间"), /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "指定时间开放提现申请入口")], -1);

const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现金额范围"), /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "按业务员下单时间计算")], -1);

const _hoisted_21 = {
  class: "card-header"
};

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "提现审核", -1);

const _hoisted_23 = {
  class: "info"
};

const _hoisted_24 = /*#__PURE__*/_createTextVNode("审核");

const _hoisted_25 = /*#__PURE__*/_createTextVNode("无需审核");

const _hoisted_26 = {
  class: "card-header"
};

const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "设置审核人", -1);

const _hoisted_28 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "任一审核人通过后可打款至业务员账户", -1);

const _hoisted_30 = {
  class: "card-header"
};

const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "设置免审人", -1);

const _hoisted_32 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "免审用户无需审核", -1);

const _hoisted_34 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_35 = /*#__PURE__*/_createTextVNode("保存");

import { ref, watch, computed, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'auto-settle-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emits('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {});
    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "自动结算",
        width: "80%",
        top: "2vh",
        "custom-class": "auto-settle-modal"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => [_hoisted_34]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary"
        }, {
          default: _withCtx(() => [_hoisted_35]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_switch), _hoisted_6])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_button, {
          type: "primary"
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_table, null, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "承担方"
          }), _createVNode(_component_el_table_column, {
            label: "服务费（%）"
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          })]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_radio_group, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_15]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_16]),
            _: 1
          })]),
          _: 1
        }), _hoisted_17, _createElementVNode("div", _hoisted_18, [_hoisted_19, _hoisted_20, _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, [_createVNode(_component_el_radio_group, null, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "1"
          }, {
            default: _withCtx(() => [_hoisted_24]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: "2"
          }, {
            default: _withCtx(() => [_hoisted_25]),
            _: 1
          })]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_el_button, {
          type: "primary",
          size: "small"
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }), _hoisted_29]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createVNode(_component_el_button, {
          type: "primary",
          size: "small"
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        }), _hoisted_33])])])])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};